import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';


@Component({
    selector: 'app-recipe-order-by-component',
    templateUrl: './recipe-order-by.component.html',
    styleUrls: ['./recipe-order-by.component.scss'],
    standalone: false
})
export class RecipeOrderByComponent implements OnDestroy, OnInit {

  public form = new FormGroup({
    order: new FormControl()
  });

  private _unsubscribeAll: Subject<any>;

  @Input() paramNameProperties = 'properties';
  @Input() paramNameDirection = 'direction';
  @Input() defaultValue = 'star,desc';
  @Input() hasWish = false;
  @Output() eventOrder = new EventEmitter<string>();

  constructor(
    protected route: ActivatedRoute,
    protected router: Router
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.form.get('order').setValue(this.defaultValue);

    const properties = this.route.snapshot.queryParams[this.paramNameProperties];
    const direction = this.route.snapshot.queryParams[this.paramNameDirection];

    if (properties && direction) {
      this.form.get('order').setValue(properties + ',' + direction);
      this.eventOrder.next(properties + ',' + direction);
    }

    this.form.valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: value => {
          const data = value.order.split(',');
          this.eventOrder.next(value.order);

          const queryParams = {};
          queryParams[this.paramNameProperties] = data[0];
          queryParams[this.paramNameDirection] = data[1];
          this.router.navigate([], {
            queryParams,
            queryParamsHandling: 'merge'
          }).then();
        },
        error: err => console.error(err)
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next({});
    this._unsubscribeAll.complete();
  }
}
